import { PipelineToolbar } from './toolbar';
import { PipelineUI } from './ui';
import { SubmitButton } from './submit';

function App() {
  return (
    <div className="min-h-screen bg-pipeline-bg text-white selection:bg-pipeline-accent/30">
      <div className="flex flex-col h-screen">
        <PipelineToolbar />
        <main className="flex-1 relative overflow-hidden">
          <PipelineUI />
        </main>
        <SubmitButton />
      </div>
    </div>
  );
}

export default App;
